import React, { useEffect, useState } from "react";
import {Table, Container, Button, Icon, Alert, Row, Col} from "design-react-kit";
import { properties } from "../../../config/properties";
import { useNavigate } from "react-router-dom";
import Spinner from "../../layout/Spinner";
import SpinnerCustom from "../../layout/Spinner";
const styles = {
    // NUOVO: Contenitore per la tabella che gestisce lo scroll
    tableContainer: {
        resize: 'vertical',
        minHeight: '20vh', // Imposta un'altezza massima (es. 60% dell'altezza del viewport)

        height: '60vh', // Imposta un'altezza massima (es. 60% dell'altezza del viewport)
        maxHeight: 'max-content',
        overflowY: 'auto', // Mostra la scrollbar verticale solo se necessario
        // border: '1px solid #e0e0e0',  Bordo sottile per definire l'area di scroll

    },
    tableHeader: {
        borderBottom: '2px solid #dee2e6',
        backgroundColor: '#06c',
        color: 'white',
        textTransform: 'uppercase',
        fontWeight: 600,
        fontSize: '1.25rem',
        letterSpacing: '0.05em',
        // --- Proprietà per lo sticky header ---
        position: 'sticky',
        top: 0, // Si "attacca" al bordo superiore del contenitore di scroll
        zIndex: 1 // Assicura che l'header stia sopra il contenuto della tabella
    },
    tableRowText: {
        color: '#333',
        fontWeight: 500, // Regular/Medium per una migliore leggibilità
        fontSize: "1rem",
        verticalAlign: 'middle', // Allinea verticalmente il testo
        textAlign: "left"
    },
    dragHandle: {
        cursor: 'move', // Cursore di spostamento sull'icona
        color: '#888', // Colore grigio per l'icona
    }
};

export default function OrdinamentoAreeCompetenza({user}) {
    const [aree, setAree] = useState([]);
    const [draggedItemIndex, setDraggedItemIndex] = useState(null);
    const [alert, setAlert] = useState({ visible: false, type: '', message: '' });
    const [loadingUser, setLoadingUser] = useState(true);
    const navigate = useNavigate();

    const handleSave = async (e) => {
        e.preventDefault();

        setAlert({ visible: false, type: '', message: '' });

        const jsonData = {
            userID: user.userID,
            cciaa: user.cciaa,
            gruppoUtente:user.gruppoUtente,
            aree: aree.map((item, index) => ({
                id: item.id,
                descrizione: item.descrAreaCompetenza,
                ordineVec: item.ordineVis,
                ordineNew: index + 1,
            }))
        };

        try {
            const response = await fetch(
                properties.fullBaseUrl + properties.baseAppUrl + "/std/service/ordina/areeCompetenza",
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(jsonData, null, 2)
                }
            );

            if(response.status === 401){

                const datasResponse = await response.json();

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return;

            }

            const result = await response.json();

            if (!response.ok || result.esito !== "OK") {
                throw new Error("Errore nel salvataggio");
            }

            setAlert({ visible: true, type: 'success', message: 'Operazione eseguita correttamente' });
            window.scrollTo({ top: 0, behavior: 'smooth' });

        } catch (err) {
            setAlert({ visible: true, type: 'danger', message: 'Errore durante l\'operazione' });
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const handleDragStart = (index) => {
        setDraggedItemIndex(index);
    };

    const handleDragOver = (ev) => {
        ev.preventDefault(); // Necessario per permettere il drop
    };

    const handleDrop = (index) => {
        if (draggedItemIndex === null || draggedItemIndex === index) return;

        const newAree = [...aree];
        const [movedItem] = newAree.splice(draggedItemIndex, 1);
        newAree.splice(index, 0, movedItem);
        setAree(newAree);
        setDraggedItemIndex(null);
    };

    async function getAreeList() {

        setAlert({ visible: false, type: '', message: '' });

        try {

            setLoadingUser(true);

            const res = await fetch(properties.fullBaseUrl + properties.baseAppUrl + "/std/service/list/areeCompetenza",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente}),

                }

            );

            if(res.status === 401){

                const datasResponse = await res.json();

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return[];

            }

            if (!res.ok) throw new Error("Errore HTTP");
            const json = await res.json();

            return json;  // qui ritorni direttamente l'array ricevuto
        } catch (e) {
            setAlert({visible: true, type: 'danger', message: 'Errore di rete o server non raggiungibile'});
            return [];
        } finally {
            setLoadingUser(false);
        }
    }


    useEffect(() => {
        async function fetchData() {
            const data = await getAreeList();
            setAree(data?.areeCompetenza ?? []);
        }
        fetchData();
    }, []);

    if (loadingUser) {
        // Puoi mostrare uno spinner o scritta di caricamento


        return (
            <Container fluid className="vh-100 d-flex justify-content-center align-items-center bg-light">
                <p className="mb-3">
                    <strong>
                        Caricamento
                    </strong>
                </p>
                <SpinnerCustom active/>
            </Container>
        );
    }

    return (
        <div className="bg-white py-5 py-lg-6">
            <Container>
                <div style={{display:"flex"}}>
                    <div style={{flex:1}}>
                        <h2 className="mb-5 ">Ordinamento Aree di Competenza</h2>


                    </div>

                    <div style={{flex:1}} align={"right"}>

                        <Button className="btn btn-outline-secondary" outline onClick={() => navigate('/private/elencoAreeCompetenza')}>

                            Annulla
                        </Button>
                        &nbsp;
                        <Button className="btn btn-outline-primary" onClick={handleSave} >

                            Salva Ordinamento
                        </Button>
                    </div>

                </div>



                {alert.visible && (
                    <Alert color={alert.type} isOpen={alert.visible} toggle={() => setAlert({ ...alert, visible: false })}>
                        {alert.message}
                    </Alert>
                )}
                <Row className="">

                <Col md={5} className="text-right">
                    <div className="guidance-box mb-4 p-3  lead">
                        <p className="mb-0">
                            Trascina le righe per riordinare i ruoli.
                            <br/>
                            L'ordine che imposti determinerà la loro visualizzazione nell'applicazione.
                        </p>
                    </div>
                </Col>
                <Col  md={7} align={"right"} className="text-right">

                    <Table hover className="border-0">
                        <thead className="bg-primary text-white">
                    <tr>
                        <th className="text-right" style={{...styles.tableHeader, width: '15%', display: "none"}}>
                            Ordine
                        </th>
                        <th scope="col" className="text-right" style={styles.tableHeader}>Area</th>
                    </tr>
                    </thead>
                    </Table>
                        <div style={styles.tableContainer} className="custom-scrollbar">
                            <Table  hover>
                    <tbody className="bg-white">
                    {aree.length > 0 ? (
                        aree.map((aree, index) => (
                            <tr
                                key={aree.id}
                                draggable
                                onDragStart={() => handleDragStart(index)}
                                onDragOver={handleDragOver}
                                onDrop={() => handleDrop(index)}
                                style={{ cursor: "move" }}
                            >
                                <td style={{ display: "none" }}>{aree.id}</td>
                                <td style={{ display: "none" }}>{aree.ordineVis}</td>
                                <td style={{ display: "none" }}>{index + 1}</td>
                                <td className="text-left" style={{...styles.tableRowText, width: '15%', height:"100px", display: "none" }}>
                                    {index+1}
                                </td>
                                <td className="text-right" style={styles.tableRowText}>{aree.descrAreaCompetenza}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="4">
                                Nessun risultato trovato
                            </td>
                        </tr>
                    )}
                    </tbody>
                </Table>
                    </div>
                </Col>
                </Row>
                <Spinner active = {!setAree}/>

            </Container>
        </div>
    );
}
